import React from "react";
import { Hero } from "../components/Hero";
import { Engagements } from "../components/Engagements";
import { Amenagements } from "../components/Amenagements";
import { Specialites } from "../components/Specialites";
import { Testimonials } from "../components/Testimonials";
import { Faq } from "../components/Faq";
import { ContactCta } from "../components/ContactCta";
export function Home() {
  return <>
      <Hero data-id="element-202" data-mp="1ziz4r7inent8" />
      <Engagements data-id="element-203" data-mp="1zjie3zu8g3vn" />
      <Amenagements data-id="element-204" data-mp="1zk1zjqj3daef" />
      <Specialites data-id="element-205" data-mp="24h0n1q892j3n" />
      <Testimonials data-id="element-206" data-mp="24g8teky7qvg0" />
      <Faq data-id="element-207" data-mp="24htnyakj2edv" />
      <ContactCta data-id="element-208" data-mp="24hk6jbdjtfjs" />
    </>;
}